import React from "react";

export const RightArrow = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="#3A4D5F"
    viewBox="0 0 1000 1000"
  >
    <path d="M750.3 450.6L345.1 30.5c-26.3-27.3-69-27.3-95.4 0 -26.3 27.3-26.3 71.5 0 98.8L607.3 500 249.7 870.7c-26.3 27.3-26.3 71.6 0 98.8 26.3 27.3 69 27.3 95.4 0l405.2-420.1C776.6 522.1 776.6 477.9 750.3 450.6z" />
  </svg>
);

export const WonderblyLogo = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 420 198"
    width="420"
    height="198"
  >
    <path
      fill="#1E5751"
      d="M102.558 140.559c-7.746 0-13.186 6.351-13.186 13.851 0 7.5 5.445 14.111 13.386 14.111 7.94 0 13.055-6.351 13.055-13.921 0-7.57-5.445-14.046-13.25-14.046l-.005.005Zm94.107.905h-5.845a.1.1 0 0 0-.1.1v25.971a.1.1 0 0 0 .1.1h5.78c6.991 0 11.356-4.36 11.356-13.02 0-8.661-4.3-13.151-11.291-13.151Zm122.613 17.504h-6.185a.1.1 0 0 0-.1.1v8.46a.1.1 0 0 0 .1.1h6.12c3.401 0 5.516-1.475 5.516-4.555 0-2.76-1.86-4.105-5.451-4.105Zm-42.809-17.529h-4.52a.1.1 0 0 0-.1.1v11.921a.1.1 0 0 0 .1.1h4.39c4.81 0 7.76-2.06 7.76-6.235 0-3.766-3.08-5.886-7.635-5.886h.005Zm36.621 8.04h5.125c3.275 0 5.015-1.395 5.015-4.11 0-2.715-1.67-3.905-4.95-3.905h-5.195a.1.1 0 0 0-.1.1v7.815a.1.1 0 0 0 .1.1h.005Z"
    />
    <path
      fill="#1E5751"
      d="M404.504 2.414 313.73 78.638a9.296 9.296 0 0 1-12.631-.216L216.43 2.585a9.293 9.293 0 0 0-12.86 0l-84.659 75.834a9.296 9.296 0 0 1-12.631.214L15.496 2.414C9.506-2.946 0 1.304 0 9.339v179.084a9.293 9.293 0 0 0 9.295 9.295h401.41a9.293 9.293 0 0 0 9.295-9.295V9.344c0-8.035-9.505-12.285-15.496-6.93ZM65.894 178.402H55.082a.096.096 0 0 1-.095-.075l-7.12-27.796c-.026-.1-.166-.1-.196 0l-7.12 27.796a.096.096 0 0 1-.095.075h-10.81a.096.096 0 0 1-.096-.075l-12.2-47.267c-.015-.065.03-.125.095-.125H29.05c.045 0 .085.03.095.08l6.496 29.221c.055.25.41.25.47 0l6.99-29.301h9.34l7.13 29.896c.026.105.17.1.196 0l6.63-29.821a.1.1 0 0 1 .095-.08H78.1c.065 0 .115.06.095.125l-12.2 47.267a.096.096 0 0 1-.096.075l-.005.005Zm37.236.77c-13.216 0-25.591-9.495-25.591-23.541 0-14.046 10.585-25.721 25.016-25.721 14.431 0 25.081 10.71 25.081 24.311 0 13.601-10.905 24.951-24.501 24.951h-.005Zm69.338-1a.1.1 0 0 1-.1.1h-10.365a.098.098 0 0 1-.085-.045l-18.001-27.776c-.055-.085-.185-.045-.185.055l.315 27.666a.1.1 0 0 1-.1.1h-11.411a.1.1 0 0 1-.1-.1v-47.267a.1.1 0 0 1 .1-.1h10.301c.035 0 .065.015.085.045l18.256 28.791c.055.085.185.045.185-.055l-.505-28.681a.1.1 0 0 1 .1-.1h11.405a.1.1 0 0 1 .1.1v47.267h.005Zm23.551.1h-16.895a.1.1 0 0 1-.1-.1v-47.267a.1.1 0 0 1 .1-.1h16.065c5.901 0 10.581 1.025 13.921 2.885 6.735 3.85 10.965 11.161 10.965 20.846 0 15.651-9.235 23.731-24.056 23.731v.005Zm57.583-36.917a.1.1 0 0 1-.1.1h-17.066a.1.1 0 0 0-.1.1v7.591a.1.1 0 0 0 .1.1h17.066a.1.1 0 0 1 .1.1v9.64a.1.1 0 0 1-.1.1h-17.066a.1.1 0 0 0-.1.1v8.341a.1.1 0 0 0 .1.1h17.066a.1.1 0 0 1 .1.1v10.45a.1.1 0 0 1-.1.1h-28.676a.1.1 0 0 1-.1-.1V130.91a.1.1 0 0 1 .1-.1h28.676a.1.1 0 0 1 .1.1v10.45-.005Zm30.382 19.846 11.495 16.916a.098.098 0 0 1-.08.155h-13.356a.103.103 0 0 1-.085-.05l-9.85-16.316h-.26v16.266a.1.1 0 0 1-.1.1h-11.411a.1.1 0 0 1-.1-.1v-47.267a.1.1 0 0 1 .1-.1h15.426c4.935 0 8.726.645 11.221 1.735 5.13 2.31 8.725 7.89 8.725 14.626 0 7.455-4.43 12.555-11.655 13.885-.07.015-.105.09-.065.15h-.005Zm46.837 13.866c-3.72 2.63-6.161 3.205-13.666 3.205h-15.681a.1.1 0 0 1-.1-.1v-47.267a.1.1 0 0 1 .1-.1h15.661c3.4 0 5.9.195 7.57.575 5.386 1.22 9.876 5.39 9.876 11.806 0 3.97-1.715 7.51-5.185 9.515-.075.04-.065.145.015.175 5.045 1.825 6.915 5.58 6.915 10.966 0 4.555-1.925 8.72-5.515 11.225h.01Zm38.202 3.11a.1.1 0 0 1-.1.1h-27.347a.1.1 0 0 1-.1-.1V130.91a.1.1 0 0 1 .1-.1h11.926a.1.1 0 0 1 .1.1v36.617a.1.1 0 0 0 .1.1h15.221a.1.1 0 0 1 .1.1v10.45Zm33.456-47.222-14.651 30.046s-.01.03-.01.045v17.131a.1.1 0 0 1-.1.1h-11.92a.1.1 0 0 1-.1-.1v-17.136s0-.03-.01-.04l-14.101-30.051a.098.098 0 0 1 .09-.14h12.426c.04 0 .08.025.095.065l7.44 18.756c.035.085.15.085.185 0l7.501-18.756a.096.096 0 0 1 .09-.065h12.975c.075 0 .12.075.09.145Z"
    />
  </svg>
);

export const WonderblyIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 43 20">
    <path
      fill="#1E5751"
      d="m40.917.244-9.182 7.71a.94.94 0 0 1-1.278-.021L21.893.26a.94.94 0 0 0-1.301 0l-8.564 7.671a.94.94 0 0 1-1.277.022L1.567.244A.94.94 0 0 0 0 .944V19.06c0 .52.42.94.94.94h40.604c.52 0 .94-.42.94-.94V.945a.94.94 0 0 0-1.567-.7Z"
    />
  </svg>
);

export const CaretLeft = () => (
  <svg width="10" height="17" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.193 15.322a.682.682 0 0 0-.209-.476L2.646 8.51 8.984 2.17a.682.682 0 1 0-.964-.965L1.2 8.026a.682.682 0 0 0 0 .965l6.82 6.82a.682.682 0 0 0 1.173-.49z"
      fill="#B5BCC3"
      fillRule="nonzero"
      stroke="#B5BCC3"
    />
  </svg>
);

export const CaretRight = () => (
  <svg width="10" height="17" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.183 1.285c.004.18.08.35.209.475L7.73 8.098l-6.338 6.338a.682.682 0 1 0 .964.964l6.82-6.82a.682.682 0 0 0 0-.964L2.356.796a.682.682 0 0 0-1.173.489z"
      fill="#B5BCC3"
      fillRule="nonzero"
      stroke="#B5BCC3"
    />
  </svg>
);

export const Hamburger = () => (
  <svg
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
    style={{ height: "1em", width: "1em" }}
  >
    <path
      d="M6 36h36v-4H6v4zm0-10h36v-4H6v4zm0-14v4h36v-4H6z"
      fill="currentColor"
    />
  </svg>
);

export const KlarnaLogo = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="61.805"
    height="25"
    viewBox="0 0 100 40.4494"
  >
    <g id="Lager_2" data-name="Lager 2">
      <g id="Layer_1" data-name="Layer 1">
        <rect fill="#ffb3c7" width="100" height="40.4494" rx="11.7384" />
        <path d="M80.0772,17.7235a6.194,6.194,0,1,0,0,10.2373v.75h3.5145V16.9727H80.0772Zm-3.1964,8.1388a3.0243,3.0243,0,1,1,3.1849-3.02A3.1059,3.1059,0,0,1,76.8808,25.8623Z" />
        <rect x="28.2027" y="11.7416" width="3.678" height="16.9694" />
        <path d="M64.1542,16.6569a4.2694,4.2694,0,0,0-3.62,1.6383V16.9733h-3.5V28.711h3.5421V22.5424a2.4754,2.4754,0,0,1,2.6383-2.6591c1.5447,0,2.4325.9228,2.4325,2.6348V28.711h3.5107V21.2464C69.1577,18.5146,66.9857,16.6569,64.1542,16.6569Z" />
        <path d="M43,17.7235a6.194,6.194,0,1,0,0,10.2373v.75h3.5145V16.9727H43Zm-3.1965,8.1388a3.0243,3.0243,0,1,1,3.1845-3.02A3.1058,3.1058,0,0,1,39.8034,25.8623Z" />
        <path d="M51.9513,18.5017V16.9728H48.353V28.7111h3.606v-5.48c0-1.8491,2.0042-2.843,3.3949-2.843.014,0,.0276.0014.0417.0015V16.9735A4.3821,4.3821,0,0,0,51.9513,18.5017Z" />
        <path d="M87.323,24.5476a2.2059,2.2059,0,1,0,2.206,2.2059A2.2057,2.2057,0,0,0,87.323,24.5476Z" />
        <path d="M25.6675,11.7384H21.8558a9.7488,9.7488,0,0,1-3.9412,7.8678l-1.51,1.131,5.8513,7.9792h4.8106l-5.3837-7.342A13.5049,13.5049,0,0,0,25.6675,11.7384Z" />
        <rect x="12.1204" y="11.7384" width="3.8185" height="16.9773" />
      </g>
    </g>
  </svg>
);

export const PlusIcon = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M18.7046 10.1477H0.999998"
      stroke="currentColor"
      strokeLinecap="round"
    />
    <path
      d="M10.1477 0.999997L10.1477 18.7046"
      stroke="currentColor"
      strokeLinecap="round"
    />
  </svg>
);

export const MinusIcon = (props) => (
  <svg
    width="20"
    height="18"
    viewBox="0 0 20 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M18.7046 9.14771H0.999998"
      stroke="currentColor"
      strokeLinecap="round"
    />
  </svg>
);
